<template>
  <TransitionRoot appear :show="show" as="template">
    <Dialog class="relative z-50" as="div" @close="closeModal">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-80" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="max-w-screen-md w-1/2 transform overflow-hidden rounded-[3px] bg-white p-6 text-left align-middle shadow-xl transition-all"
            >
              <DialogTitle v-if="title.length > 0" as="h3" class="text-lg font-bold leading-6 text-gray-900 mb-6">
                {{ title }}
              </DialogTitle>
              <DialogDescription v-if="description?.length">
                {{ description }}
              </DialogDescription>
              <slot></slot>
              <div v-if="actionButtons?.length" class="mt-8 flex flex-wrap gap-2 justify-end">
                <LSButton
                  v-for="actionButton in actionButtons"
                  :key="`${actionButton.label}`"
                  :type="actionButton.type"
                  @click="actionButton.onClick"
                  >{{ actionButton.label }}</LSButton
                >
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle, DialogDescription } from '@headlessui/vue'
import LSButton from '@/components/LSButton.vue'

import type { Buttontype } from '@/types'

defineProps<{
  title: string
  show: boolean
  description?: string
  actionButtons?: { label: string; type: Buttontype; onClick: () => void }[]
}>()

const emit = defineEmits<{
  closeModal: []
}>()

const closeModal = () => {
  emit('closeModal')
}
</script>
